import { render, staticRenderFns } from "./ViewerCurrentNotes.vue?vue&type=template&id=37ddbedc"
import script from "./ViewerCurrentNotes.vue?vue&type=script&lang=js"
export * from "./ViewerCurrentNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports